import { PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

export const baseVariants = cva(
  'min-w-0 overflow-hidden flex items-center gap-2 transition-border border border-transparent duration-200 ease-in-out w-full',
  {
    variants: {
      variant: {
        default:
          'bg-base-500 data-[is-invalid=false]:focus-within:ring-offset-background hover:border-carbon data-[is-invalid=false]:focus-within:border-primary-focus-border focus:border-primary-focus-border focus-within:hover:border-primary-focus-border data-[is-invalid=false]:focus-within:outline-0 data-[is-invalid=false]:focus-within:ring-offset-2 data-[disabled=true]:bg-base-500',
        secondary:
          'bg-base-300 hover:data-[disabled=false]:bg-hover-base-300-hover',
        send: 'bg-base-300 data-[is-invalid=false]:hover:!bg-hover-base-300-hover !h-[64px] !rounded-[16px] data-[is-invalid=false]:peer-focus:!bg-hover-base-300-hover',
        small: 'bg-base-300 h-[48px] rounded-[16px]',
        // TODO: deprecated
        dashboard:
          'bg-base-300 hover:data-[disabled=false]:!bg-hover-base-300-hover',
      },
      disabled: {
        true: 'opacity-50 cursor-not-allowed hover:border-transparent',
      },
      isInvalid: {
        true: 'border-negative-500 hover:border-negative-500 focus-within:hover:border-negative-500',
      },
      size: {
        default: 'h-[50px] px-[14px] py-2 rounded-[10px]',
        sm: 'h-10 rounded-[12px] px-[6px] py-2',
        dashboard: 'h-[50px] px-[14px] py-2 rounded-[16px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      isInvalid: false,
      disabled: false,
    },
  },
);

export interface IFloatingLabelClassNames {
  wrapper: string;
  content: string;
  placeholder: string;
  description: string;
}

export type TBaseVariants = VariantProps<typeof baseVariants>;

interface IFloatingLabel extends TBaseVariants, React.ComponentProps<'div'> {
  htmlFor?: string;
  placeholder?: string;
  description?: string;
  isInput?: boolean;
  classNames?: Partial<IFloatingLabelClassNames>;
  className?: string;
  endContent?: React.ReactNode;
  customPlaceholder?: string;
  triggerClassName?: string;
}

export type TFloatingLabel = PropsWithChildren<IFloatingLabel>;
